import { OrdersListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';

export const createOrdersTableChipsConfig = (
  t: TFunction
): FiltersConfig<OrdersListFilterInput> => ({
  status: {
    label: t('status'),
    renderValue: formatEnum,
  },
});

export const excludedFilterFields: (keyof OrdersListFilterInput)[] = ['number'];
